import React from 'react'

import { useClosuresList } from '../hooks'

import Header from '../../common/components/Header'
import ClosureListItem from './ClosureListItem'

import styles from './ClosureList.module.css'

const ClosureList = () => {
  const [{ closureIds, isLoading }] = useClosuresList()

  return (
    <div>
      <Header>
        {closureIds.length} Closures{' '}
        {isLoading && <i className="fa fa-spinner fa-spin"></i>}
      </Header>
      <ul className={styles.list}>
        {closureIds.map((closureId, i) => (
          <ClosureListItem closureId={closureId} key={i} />
        ))}
      </ul>
    </div>
  )
}

export default ClosureList
